export const JOB_APPLICATION_EXPORT_FETCH_REQUEST = 'job-application/export-fetch-request'
export const JOB_APPLICATION_EXPORT_FETCH_SUCCESS = 'job-application/export-fetch-success'
export const JOB_APPLICATION_EXPORT_FETCH_FAILED = 'job-application/export-fetch-failed'
